import {INavData} from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Kahpoo back office',
    url: '/dashboard',
    icon: 'fa fa-home'
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'Offres Kahpoo',
    url: 'gestion-des-offres',
    icon: 'fa fa-gift',
    children: [
      {
        name: 'Forfait abonnement',
        url: 'pass',
        icon: 'fa fa-cubes'
      },
      {
        name: 'Offres d\'emploi',
        url: 'employe-offer',
        icon: 'fa fa-briefcase'
      }
    ]
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'Gestion reversement\n',
    url: 'reversement-effectues',
    icon: 'fa fa-money-bill-trend-up',
    children: [
      {
        name: 'Liste des vendeurs',
        url: 'sellers',
        icon: 'icon-check'
      },
      {
        name: 'Liste des vendeurs_new',
        url: 'kahpoo-sellers',
        icon: 'icon-check'
      },
      {
        name: 'Reversements en attente de paiement',
        url: 'reversement-encours',
        icon: 'icon-check'
      },
      {
        name: 'Rev. effectués',
        url: 'reversement-effectues',
        icon: 'icon-check'
      }
    ]
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'Commissions',
    url: 'commisions',
    icon: 'fa fa-money',
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'Gestion utilisateurs',
    url: 'users',
    icon: 'fa fa-users',
    children: [
      {
        name: 'Utilisateurs',
        url: 'users',
        icon: 'icon-user'
      },
      {
        name: 'Commerciaux',
        url: 'commerciaux',
        icon: 'icon-user'
      },
      {
        name: 'Utilisateurs enrolés',
        url: 'enroles',
        icon: 'icon-user'
      },
      {
        name: 'Vendeurs avec ventes',
        url: 'users-with-sold-products',
        icon: 'icon-user'
      }
    ]
  },
  {
    divider: true,
    class: 'bg-light'
  },

  /*{
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'Transactions',
    url: 'transactions',
    icon: 'fa fa-credit-card',
  },*/
  {
    name: 'Transactions',
    url: 'commande',
    icon: 'fa fa-shopping-cart',
    children: [
      {
        name: 'Commande',
        url: 'commande',
        icon: 'icon-check'
      },
      {
        name: 'Carte cadeaux',
        url: 'giftcard',
        icon: 'icon-check'
      }
    ]
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'Boutiques',
    url: 'boutiques',
    icon: 'fa fa-gift',
    children: [
      {
        name: 'Boutiques',
        url: 'boutiques',
        icon: 'fas fa-shop'
      },
      {
        name: 'Publications',
        url: 'publications',
        icon: 'fas fa-book'
      },
      // {
      //   name: 'Tout les promotions',
      //   url: 'all-promotions-offer-active',
      //   icon: 'fas fa-gift'
      // },
      {
        name: 'Promotions vendeurs',
        url: 'promotion-offer-active',
        icon: 'fas fa-gift'
      },
      {
        name: 'Mise en avant',
        url: 'promote',
        icon:'fas fa-star'
      },
      {
        name: 'Catégorie',
        url: 'categorie-shop',
        icon: 'icon-check'
      },
      {
        name: 'Sous-catégorie',
        url: 'sous-categorie',
        icon: 'fa fa-cogs'
      },
      {
        name: 'Caractéristique',
        url: 'characteristics',
        icon: 'icon-check'
      },
      {
        name: 'Domain',
        url: 'domain',
        icon: 'icon-star'
      },
      {
        name: 'Commandes',
        url: 'orderitem',
        icon: 'icon-check'
      },
      {
        name: 'Réservations',
        url: 'reservation',
        icon: 'icon-check'
      },
      {
        name: 'Utilisateurs gestionnaires',
        url: 'utilisateurs-gestionnaires',
        icon: 'fa fa-shopping-bag'
      }
    ]
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'Newsletter',
    url: 'newletter',
    icon: 'fa fa-mail-reply',
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'Blog',
    url: 'blog',
    icon: 'fa fa-pencil',
    children: [
      {
        name: 'Images',
        url: 'images',
        icon: 'fa fa-folder'
      },
      {
        name: 'Catégorie',
        url: 'categorie',
        icon: 'fa fa-folder'
      },
      {
        name: 'Articles',
        url: 'article',
        icon: 'fa fa-file'
      }
    ]
  },
  {
    divider: true,
    class: 'bg-light'
  },
  // {
  //   name: 'Audit',
  //   url: 'audit',
  //   icon: 'fa fa-tripadvisor',
  // },
  // {
  //   divider: true,
  //   class: 'bg-light'
  // },

  {
    name: 'Wallet',
    url: 'wallet',
    icon: 'fa fa-money',
    children: [
      {
        name: 'Wallet kahpoo',
        url: 'kahpoo',
        icon: 'fa fa-check'
      },
      {
        name: 'Promotion',
        url: 'promotion',
        icon: 'fa fa-check'
      }
    ]
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    // name: 'Autres',
    // url: '/others',
    // icon: 'icon-wrench',
    name: 'Parrainage',
    url: '/others',
    icon: 'icon-people',
    children: [
      {
        name: 'Filleuls',
        url: 'filleule',
        icon: 'icon-user'
      },
      {
        name: 'Parrains',
        url: 'parrainage',
        icon: 'icon-user'
      }
    ]
  },
  {
    divider: true,
    class: 'bg-light'
  },

  {
    name: 'Espace Privé',
    url: 'private-space',
    icon: 'fa fa-user-lock',
  },
  {
    divider: true,
    class: 'bg-light'
  },
  {
    name: 'FAQ',
    url: 'faq',
    icon: 'icon-star'
  },
  {
    name: 'Localisation',
    url: '/localisation',
    icon: 'icon-location-pin',
    children: [
      {
        name: 'Pays',
        url: 'country',
        icon: 'icon-location-pin'
      },
      {
        name: 'Ville',
        url: 'city',
        icon: 'icon-location-pin'
      },
      {
        name: 'Quartier',
        url: 'district',
        icon: 'icon-location-pin'
      },
      {
        name: 'Rue',
        url: 'street',
        icon: 'icon-location-pin'
      },
      {
        name: 'Zone',
        url: 'zone',
        icon: 'icon-location-pin'
      },
      {
        name: 'Frais de déplacement',
        url: '/tripExpense',
        icon: 'icon-check'
      },
      {
        name: 'Zone de livraison',
        url: '/zone',
        icon: 'icon-check'
      }
    ]
  }

];
